/**
 * Generated by the safari control rack.
 *
 * The @piece block below is the panel's round-trip format. Edit the component
 * freely; as long as that block survives, the rack can reopen this file.
 */
/* @piece
{
  "seed": 27201,
  "clock": {
    "rate": 0.15,
    "phase": 0,
    "loop": 0
  },
  "frame": {
    "zoom": 2.5,
    "rotation": 0.19,
    "orbit": 0,
    "tilt": 0.29,
    "perspective": 0.2,
    "wobble": 0.09,
    "breathe": 0,
    "vignette": 0,
    "groundHue": 0,
    "groundSaturation": 0,
    "groundLightness": 0.08
  },
  "pointer": {
    "path": "none",
    "amount": 0.35,
    "jitter": 0.6
  },
  "layers": [
    {
      "enabled": true,
      "timeScale": 1,
      "phaseOffset": 0,
      "field": {
        "type": "interference",
        "sources": 4,
        "frequency": 1.4,
        "amplitude": 0.8,
        "falloff": 0.2,
        "drift": 1,
        "travel": 0
      },
      "substrate": {
        "type": "grid",
        "density": 24,
        "jitter": 0.14,
        "chain": "columns"
      },
      "motion": {
        "displace": 0.3,
        "shift": 0,
        "axis": "radial",
        "align": "fixed",
        "twist": -1.65,
        "spin": 0.55
      },
      "mark": {
        "geometry": "tick",
        "scale": 1.2,
        "sides": 4,
        "turn": 0.125,
        "glyphMode": "sign",
        "glyphs": "/\\|"
      },
      "ink": {
        "gain": 1.6,
        "weight": 2,
        "bands": 0,
        "invert": 0.16,
        "opacity": 0.47,
        "hue": 0,
        "saturation": 0.02,
        "lightness": 0.46,
        "persistence": 0
      },
      "transform": {
        "scale": 1,
        "x": 0,
        "y": 0,
        "rotation": 0,
        "spin": 0
      }
    }
  ]
}
*/
import Visualization from '../../vendor/skargard/react/Visualization.jsx'

// interference field, sampled on a grid substrate,
// drawn as tick marks. Frame is free-running.
//
// Hand-edited from the rack's export: frame.groundSaturation dropped from 0.02
// to 0, the engine's switch for "follow the theme". The piece paints on
// --art-paper instead of its own near-black, so as a full-page backdrop it
// reads as the page rather than as a dark sheet laid over it.
const piece = {
  "seed": 27201,
  "clock": {
    "rate": 0.15,
    "phase": 0,
    "loop": 0
  },
  "frame": {
    "zoom": 2.5,
    "rotation": 0.19,
    "orbit": 0,
    "tilt": 0.29,
    "perspective": 0.2,
    "wobble": 0.09,
    "breathe": 0,
    "vignette": 0,
    "groundHue": 0,
    "groundSaturation": 0,
    "groundLightness": 0.08
  },
  "pointer": {
    "path": "none",
    "amount": 0.35,
    "jitter": 0.6
  },
  "layers": [
    {
      "enabled": true,
      "timeScale": 1,
      "phaseOffset": 0,
      "field": {
        "type": "interference",
        "sources": 4,
        "frequency": 1.4,
        "amplitude": 0.8,
        "falloff": 0.2,
        "drift": 1,
        "travel": 0
      },
      "substrate": {
        "type": "grid",
        "density": 24,
        "jitter": 0.14,
        "chain": "columns"
      },
      "motion": {
        "displace": 0.3,
        "shift": 0,
        "axis": "radial",
        "align": "fixed",
        "twist": -1.65,
        "spin": 0.55
      },
      "mark": {
        "geometry": "tick",
        "scale": 1.2,
        "sides": 4,
        "turn": 0.125,
        "glyphMode": "sign",
        "glyphs": "/\\|"
      },
      "ink": {
        "gain": 1.6,
        "weight": 2,
        "bands": 0,
        "invert": 0.16,
        "opacity": 0.47,
        "hue": 0,
        "saturation": 0.02,
        "lightness": 0.46,
        "persistence": 0
      },
      "transform": {
        "scale": 1,
        "x": 0,
        "y": 0,
        "rotation": 0,
        "spin": 0
      }
    }
  ]
}

export default function Fold() {
  return <Visualization piece={piece} />
}

Fold.piece = piece
